import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useUserMedia } from "../../../custom-hooks/useUserMedia";
import {
  setFaceAbsencePeriod,
  updateFaceAbsencePeriod,
} from "../../../redux/features/snapshot/snapshotSlice";
import { updateAlignFace } from "../../../redux/features/warning/warningSlice";
import { takeSnapshotAsync } from "../../../redux/features/snapshot/snapshotActions";
import { setMultiFace } from "../../../redux/features/warning/warningSlice";
import {
  setCam2Start,
  setFaceAPI,
} from "../../../redux/features/timer/timerSlice";
import { store } from "../../../redux/store";
import logType from "../../../redux/features/logTypes";
import { drawResults, getDetector } from "../../../utils/midia-pipe-detect";
import { isMobile } from "@tensorflow/tfjs-core/dist/device_util";
import { VIDEO_SIZE } from "../../../utils/utils";

const BgVideo = ({ className }) => {
  const examStarted = useSelector((state) => state.timer.examStarted);
  const timeInterval = useRef();
  // const faceAbsencePeriod = useSelector(
  //   (state) => state.snapshot.faceAbsencePeriod
  // );
  const isAbsent = useSelector((state) => state.snapshot.isAbsent);
  const takeSnapshotReg = useSelector(
    (state) => state.snapshot.takeSnapshotReg
  );
  const examEnded = useSelector((state) => state.timer.examEnded);
  const timeCount = useSelector((state) => state.timer.timeCount);
  const onTakeshotReg = useRef(false);
  const detector = useRef();
  const dispatch = useDispatch();
  const videoEl = useRef();
  const canvasEl = useRef();
  const displaySize = useRef({});
  // const [loaded, setLoaded] = useState(false);
  const [context, setContext] = useState();

  const loadDetector = async () => {
    try {
      const myDetector = await getDetector({ maxFaces: 7 });
      console.log({ myDetector });

      detector.current = myDetector;
      // if (myDetector) {
      // }
      return myDetector;
    } catch (error) {
      console.error({ error });
    }
  };
  const requestedMedia = useMemo(
    () => ({
      audio: false,
      video: {
        facingMode: "user",
        width: isMobile()
          ? VIDEO_SIZE["360 X 270"].width
          : VIDEO_SIZE["480 X 360"].width,
        height: isMobile()
          ? VIDEO_SIZE["360 X 270"].height
          : VIDEO_SIZE["480 X 360"].height,

        // resizeMode: "crop-and-scale"
      },
    }),
    []
  );
  const mediaStream = useUserMedia(requestedMedia);

  useEffect(() => {
    if (onTakeshotReg.current) {
      //dispatch periodic snapshot
      dispatch(
        takeSnapshotAsync(
          videoEl.current,
          displaySize.current,
          logType.PERIODIC_SNAPSHOT
        )
      );
    } else {
      onTakeshotReg.current = true;
    }
  }, [takeSnapshotReg, dispatch]);

  /*
    useEffects hooks for initiators and preventive rerenders
    **/
  useEffect(() => {
    videoEl.current.srcObject = mediaStream;
    return () => {
      //flusing media stream unmount
      mediaStream?.getTracks().forEach((track) => track.stop());
      clearInterval(timeInterval.current);
    };
  }, [mediaStream]);

  // const loaded = isFaceDetectionModelLoaded(faceapi);

  useEffect(() => {
    setContext(canvasEl.current.getContext("2d"));
    loadDetector()
      .then((myDetector) => {
        console.log({ myDetector });
        detector.current = myDetector;
        console.log("the load detector has loaded");
        dispatch(setFaceAPI(true));
      })
      .catch((e) => {
        //do something
        loadDetector();
        console.log(e);
      });
  }, [dispatch]);

  useEffect(() => {
    if (examStarted) {
      dispatch(updateFaceAbsencePeriod());
      console.log("dispatch face update");
      const {
        warning: { multiFaceCount, multiFaceLapseTimeInSec },
      } = store.getState();
      console.log(multiFaceCount, multiFaceLapseTimeInSec);
      if (multiFaceCount === multiFaceLapseTimeInSec) {
        dispatch(
          takeSnapshotAsync(
            videoEl.current,
            displaySize.current,
            logType.MULTIPLE_FACE
          )
        );
      }
    }
  }, [timeCount, examStarted, dispatch]);

  useEffect(() => {
    if (examStarted && isAbsent) {
      console.log("face absence working");
      dispatch(
        takeSnapshotAsync(
          videoEl.current,
          displaySize.current,
          logType.FACE_ABSENCE
        )
      );
    }
  }, [dispatch, examStarted, isAbsent]);

  const onLoadVideo = () => {
    console.info("this is the log boss");
    displaySize.current = {
      width: videoEl.current.videoWidth,
      height: videoEl.current.videoHeight,
    };
    canvasEl.current.width = videoEl.current.videoWidth;
    canvasEl.current.height = videoEl.current.videoHeight;
    const myContext = canvasEl.current.getContext("2d");
    console.log(displaySize);
    myContext.translate(videoEl.current.videoWidth, 0);
    myContext.scale(-1, 1);
    setContext(myContext);
  };

  function handleCanPlay() {
    videoEl.current.play();
    clearInterval(timeInterval.current);
    timeInterval.current = setInterval(() => {
      handleProgress();
    }, 500);
    dispatch(setCam2Start(true));
  }

  const handleProgress = async () => {
    context.clearRect(0, 0, canvasEl.current.width, canvasEl.current.height);
    if (!detector.current?.faceDetectorSolution) {
      console.log("the detector is still loading", { detector });
      return;
    }
    if (examEnded) {
      clearInterval(timeInterval.current);
      return;
    }
    let results = await detector.current?.estimateFaces(videoEl.current, {
      flipHorizontal: false,
    });

    if (!results || results.length < 1) {
      dispatch(updateAlignFace(true));
    } else {
      dispatch(updateAlignFace(false));
    }
    let timeout;
    if (results.length > 1) {
      dispatch(setMultiFace(true));
      timeout = setTimeout(() => {
        //dispactch detect
        // dispatch(
        //   takeSnapshotAsync(
        //     videoEl.current,
        //     displaySize.current,
        //     logType.MULTIPLE_FACE
        //   )
        // );

        clearTimeout(timeout);
      }, 500);
    } else if (results.length <= 1) {
      dispatch(setMultiFace(false));
    }

    if (results.length >= 1) {
      console.log("there is result");
      dispatch(setFaceAbsencePeriod(0));
      if (examEnded && detector.current?.faceDetectorSolution) {
        //console.log("pause is pressed");
        clearInterval(timeInterval.current);
        return;
      }
      // results = results.map((result) =>
      //   result.forSize(displaySize.current.width, displaySize.current.height)
      // );

      //drawing box with results
      // drawResults(context, results, true, false);
      results.forEach((result) => {
        if (
          result.box.xMin < -20 ||
          result.box.xMax > displaySize.current.width + 20 ||
          result.box.yMin < -20 ||
          result.box.yMax > displaySize.current.height + 20
        ) {
          dispatch(updateAlignFace(true));
        } else {
          dispatch(updateAlignFace(false));
        }
      });

      // make <canvas> of the same size
    } else {
      context.clearRect(0, 0, canvasEl.current.width, canvasEl.current.height);
    }
  };

  if (examEnded) videoEl.current?.pause();
  window.onkeydown = null;
  return (
    <div className={`${className}`}>
      <div className="position-relative">
        <video
          ref={videoEl}
          onCanPlay={handleCanPlay}
          // onProgress={handleProgress}
          autoPlay
          muted
          playsInline
          style={{
            width: "auto",
            height: "auto",
            transform: "scaleX(-1)",
            // visibility:"hidden",
          }}
          onLoadedMetadata={onLoadVideo}
          height={360}
          width={480}
        ></video>
        <canvas
          className="position-absolute top-0 start-0"
          ref={canvasEl}
        ></canvas>
      </div>
    </div>
  );
};
BgVideo.propTypes = {
  className: PropTypes.string,
};

export default BgVideo;
